export default __webpack_public_path__ + "static/Floorplan_PH3AR-LL_v1-84ad14969cfe41b2253cf56814f7eed4.svg";